module.exports = __webpack_public_path__ + "static/media/tab-house-creamy.af76dad8.png";